const weaponTypeMasteries = {
  'battleaxe': 'topple',
  'blowgun': 'vex',
  'club': 'slow',
  'dagger': 'nick',
  'dart': 'vex',
  'flail': 'sap',
  'glaive': 'graze',
  'greataxe': 'cleave',
  'greatclub': 'push',
  'greatsword': 'graze',
  'halberd': 'cleave',
  'hand-crossbow': 'vex',
  'handaxe': 'vex',
  'heavy-crossbow': 'push',
  'javelin': 'slow',
  'lance': 'topple',
  'light-crossbow': 'slow',
  'light-hammer': 'nick',
  'longbow': 'slow',
  'longsword': 'sap',
  'maul': 'topple',
  'mace': 'sap',
  'morningstar': 'sap',
  'musket': 'slow',
  'pike': 'push',
  'pistol': 'vex',
  'quarterstaff': 'topple',
  'rapier': 'vex',
  'scimitar': 'nick',
  'shortbow': 'vex',
  'shortsword': 'vex',
  'sickle': 'nick',
  'spear': 'sap',
  'trident': 'topple',
  'war-pick': 'sap',
  'warhammer': 'push',
  'whip': 'slow',
};

export default weaponTypeMasteries;
